import ProtocoloUso from '@/components/ProtocoloUso'
import OpcoesCompra from '@/components/OpcoesCompra'
import ProtocoloOleosQueTemho from '@/components/ProtocoloOleosQueTemho'
import CalculadoraOleos from '@/components/CalculadoraOleos'
import GuideBox from '@/components/GuideBox'
import OutrasOpcoes from '@/components/OutrasOpcoes'

interface Props {
  lead: any
}

// Wrapper que decide se exibe a Seção 6 (lógica de visibilidade delegada ao OutrasOpcoes)
function OutrasOpcoesWrapper({ lead }: Props) {
  const prioridades: string[] = (lead?.prioridades || lead?.prioridades_saude || [])
  if (prioridades.length === 0) return null

  return (
    <>
      <div className="py-6">
        <hr style={{ borderColor: '#EDE0D4' }} />
      </div>
      <div>
        <GuideBox>
          {`No campo abaixo OUTRAS OPÇÕES DE ÓLEOS RECOMENDADOS PARA SEUS DESCONFORTOS apresente essas informações durante o atendimento como sugestão complementar ao protocolo principal, se você perceber que há necessidade e até disposição para o cliente investir. Estes outros óleos potencializam os resultados para os desconfortos específicos deste cliente. Podem ser até óleos sugestivos para a próxima compra.`}
        </GuideBox>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-1.5 h-8 rounded-full" style={{ backgroundColor: '#2D6A4F' }} />
          <h3 className="text-xl font-semibold" style={{ color: '#2D6A4F', fontFamily: 'Cormorant Garamond, serif' }}>
            Outras Opções de Óleos Recomendados para Seus Desconfortos
          </h3>
        </div>
        <OutrasOpcoes lead={lead} />
      </div>
    </>
  )
}

export default function AdminModalTabs({ lead }: Props) {
  return (
    <div className="mt-6 space-y-0">
      {/* Seção — Opções de Compra */}
      <div>
        <GuideBox>
          {`No campo abaixo OPÇÕES DE COMPRA apresente as opções durante o atendimento, nunca antes.

Comece sempre pela Opção 1 (Kit Completo) pois é a de maior valor e melhor custo-benefício. Se houver resistência ao investimento apresente a Opção 3 (Protocolo Prioritário) como ponto de entrada.

Nunca apresente os valores por mensagem antes de ter conversado com a cliente.`}
        </GuideBox>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-1.5 h-8 rounded-full" style={{ backgroundColor: '#2D6A4F' }} />
          <h3 className="text-xl font-semibold" style={{ color: '#2D6A4F', fontFamily: 'Cormorant Garamond, serif' }}>
            Opções de Compra
          </h3>
        </div>
        <OpcoesCompra lead={lead} />
      </div>

      {/* Seção — Calculadora de Óleos (Brasil ou leads sem país definido — leads legados) */}
      {(!lead?.pais || lead?.pais === 'Brasil') && (
        <>
          <div className="py-6">
            <hr style={{ borderColor: '#EDE0D4' }} />
          </div>
          <div>
            <GuideBox>
              {`Use a calculadora para montar orçamentos personalizados em tempo real. Digite o nome do óleo, marque os produtos desejados e o Sistema Descubra seus Óleos calcula automaticamente subtotal, frete, taxa de adesão e parcelamento. Ideal para responder rapidamente a dúvidas de preço durante o atendimento.`}
            </GuideBox>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-1.5 h-8 rounded-full" style={{ backgroundColor: '#2D6A4F' }} />
              <h3 className="text-xl font-semibold" style={{ color: '#2D6A4F', fontFamily: 'Cormorant Garamond, serif' }}>
                Calculadora de Óleos
              </h3>
            </div>
            <CalculadoraOleos lead={lead} />
          </div>
        </>
      )}

      {/* Divisória */}
      <div className="py-6">
        <hr style={{ borderColor: '#EDE0D4' }} />
      </div>

      {/* Seção — Protocolo de Uso */}
      <div>
        <GuideBox>
          {`No campo abaixo PROTOCOLO DE USO envie somente essas informações após a confirmação da compra dos óleos essenciais. Esse é o presente da cliente.

Personalize a mensagem de envio com o nome dela e uma frase de encorajamento. É o início da jornada dela com os óleos.

Caso ela não compre todos os óleos essenciais detalhados no Protocolo de Uso envie apenas as informações dos óleos essenciais que ela comprou.`}
        </GuideBox>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-1.5 h-8 rounded-full" style={{ backgroundColor: '#2D6A4F' }} />
          <h3 className="text-xl font-semibold" style={{ color: '#2D6A4F', fontFamily: 'Cormorant Garamond, serif' }}>
            Protocolo de Uso
          </h3>
        </div>
        <ProtocoloUso lead={lead} />
      </div>

      {/* Divisória */}
      <div className="py-6">
        <hr style={{ borderColor: '#EDE0D4' }} />
      </div>

      {/* Seção — Protocolo com Óleos que Tenho */}
      <div>
        <GuideBox>
          {`No campo abaixo PROTOCOLO DE ÓLEO PERSONALIZADO use quando a cliente comprou óleos essenciais personalizados ou já tem no estoque. Selecione manualmente os óleos essenciais e gere o protocolo personalizado.`}
        </GuideBox>
        <ProtocoloOleosQueTemho lead={lead} />
      </div>

      {/* Seção 6 — Outras Opções de Óleos Recomendados */}
      <OutrasOpcoesWrapper lead={lead} />
    </div>
  )
}
